export default "__VITE_ASSET__DR9pxpOq__"